import { FALLBACK_USER_NAME, SYSTEM_USER_NAME_MAP } from './systemUserNames'
import type { HeaderUser, SupportedUserLanguage } from './types'

function normalizeUserName(name: string) {
  return name.toLowerCase().replace(/\s+/g, ' ')
}

export function getLocalizedUserDisplayName(user: HeaderUser, language: SupportedUserLanguage) {
  const rawName = user?.real_name?.trim() || user?.user_name?.trim()

  if (!rawName) {
    return FALLBACK_USER_NAME[language]
  }

  return SYSTEM_USER_NAME_MAP[normalizeUserName(rawName)]?.[language] || rawName
}
